<template>
  <div class="TileData px-3 pb-4 pt-4">
    <div v-if="getHighlighted" class="TileData__title d-flex">
      <span class="align-self-center w-100 d-flex justify-content-between mb-3">
        Pand eigenschappen
        <span>
          <FontAwesomeIcon :icon="['fal', 'location']" class="mr-2" @click="flyTo" />
          <FontAwesomeIcon :icon="['fal', 'times-circle']" @click="handleClose"  />
        </span>
      </span>
    </div>
    <div v-if="getHighlighted">
      <table>
        <tbody>
          <tr>
            <td>Type eigenaar</td>
            <td>{{ eigendom }}</td>
          </tr>
          <tr>
            <td>Energielabel</td>
            <td>{{ energielabel }}</td>
          </tr>
          <tr>
            <td>Woz Waardeklasse</td>
            <td>{{ wozwaardeklasse }}</td>
          </tr>
          <tr>
            <td>Bouwperiode</td>
            <td>{{ bouwjaarklasse }}</td>
          </tr>
          <tr>
            <td>Gebruiksdoel</td>
            <td>{{ gebruiksdoel }}</td>
          </tr>
        </tbody>
      </table>
      <h5 class="mt-3">
        Hitte eiland effect
      </h5>
      <table>
        <tbody>
          <tr>
            <td>Hitte eiland (25m)</td>
            <td>{{ stedelijk_hitte_eiland_effect_25.toFixed(2) }} graden</td>
          </tr>
          <tr>
            <td>Hitte eiland (500m)</td>
            <td>{{ stedelijk_hitte_eiland_effect_500.toFixed(2) }} graden</td>
          </tr>
          <tr>
            <td>Gevoelstemperatuur (25m)</td>
            <td>{{ hittekaart_gevoelstemperatuur_25.toFixed(2) }} graden</td>
          </tr>
          <tr>
            <td>Gevoelstemperatuur (500m</td>
            <td>{{ hittekaart_gevoelstemperatuur_500.toFixed(2) }} graden</td>
          </tr>
        </tbody>
      </table>
      <h5 class="mt-3">
        Waterdiepte bij neerslag
      </h5>
      <table>
        <tbody>
          <tr>
            <td>t/m 100 jaar (25m)</td>
            <td>{{ waterdiepte_bij_intense_neerslag_1_100_jaar_25.toFixed(2) }} cm</td>
          </tr>
          <tr>
            <td>t/m 100 jaar (500m)</td>
            <td>{{ waterdiepte_bij_intense_neerslag_1_100_jaar_500.toFixed(2) }} cm</td>
          </tr>
          <tr>
            <td>t/m 1000 jaar (25m)</td>
            <td>{{ waterdiepte_bij_intense_neerslag_1_1000_jaar_25.toFixed(2) }} cm</td>
          </tr>
          <tr>
            <td>t/m 1000 jaar (500m)</td>
            <td>{{ waterdiepte_bij_intense_neerslag_1_1000_jaar_500.toFixed(2) }} cm</td>
          </tr>
        </tbody>
      </table>
      <div class="mt-2 text-muted">
        BAG ID: {{ pand_id }}
      </div>
    </div>
    <div v-else>
      Klik op een gebouw om de gebouwdetails te bekijken.
    </div>
  </div>
</template>

<script>

import { mapGetters, mapMutations } from 'vuex';

import mapboxgl from 'mapbox-gl'

export default {
  props: {
    loaded: {
      type: Boolean,
      value: false
    }
  },
  data() {
    return {
      bouwblok_auto: false,
      bouwjaar: false,
      bouwjaarklasse: false,
      codering: false,
      codering_short: false,
      eigendom: false,
      energielabel: false,
      gebruiksdoel: false,
      hittekaart_gevoelstemperatuur_25: false,
      hittekaart_gevoelstemperatuur_25_code: false,
      hittekaart_gevoelstemperatuur_500: false,
      hittekaart_gevoelstemperatuur_500_code: false,
      kea_barcode_25: false,
      kea_barcode_500: false,
      pand_id: false,
      stedelijk_hitte_eiland_effect_25: false,
      stedelijk_hitte_eiland_effect_25_code: false,
      stedelijk_hitte_eiland_effect_500: false,
      stedelijk_hitte_eiland_effect_500_code: false,
      waterdiepte_bij_intense_neerslag_1_100_jaar_25: false,
      waterdiepte_bij_intense_neerslag_1_100_jaar_25_code: false,
      waterdiepte_bij_intense_neerslag_1_100_jaar_500: false,
      waterdiepte_bij_intense_neerslag_1_100_jaar_500_code: false,
      waterdiepte_bij_intense_neerslag_1_1000_jaar_25: false,
      waterdiepte_bij_intense_neerslag_1_1000_jaar_25_code: false,
      waterdiepte_bij_intense_neerslag_1_1000_jaar_500: false,
      waterdiepte_bij_intense_neerslag_1_1000_jaar_500_code: false,
      wozwaardeklasse: false,
      coordinates: null
    }
  },
  computed: {
    ...mapGetters('map', [
      'getForecastStatus',
      'getHighlighted'
    ]),
  },
  watch: {
    loaded: function() {
      this.$store.map.on('click', 'hexagons', this.selectTile)
      
      // Cursor on hover
      this.$store.map.on('mouseenter', 'hexagons', () => {
        this.$store.map.getCanvas().style.cursor = 'pointer'
      });
      this.$store.map.on('mouseleave', 'hexagons', () => {
        this.$store.map.getCanvas().style.cursor = ''
      });
    }
  },
  mounted() {
    this.setHighlighted({ pand_id: false })
  },
  methods: {
    ...mapMutations('map', [
      'setHighlighted'
    ]),
    selectTile(e) {
      if (e.features.length === 0 || e._defaultPrevented) {
        return 
      }

      console.log(e.features)

      Object.keys(this._data)
        .forEach((key) => {
          this[key] = e.features[0].properties[key] || null;
        })
      
      if (this.getHighlighted === this.pand_id) {
        this.setHighlighted({ pand_id: false })
        this.pand_id = false
      } else {
        this.coordinates = this.getCenterOfPolygon({
          coordinates: e.features[0].geometry.coordinates[0]
        })

        // If we're not zoomed in, zoom in.
        if (this.$store.map.getZoom() < 16.5 ) {
          this.flyTo()
        }

        this.setHighlighted({ pand_id: this.pand_id })
      }
    },
    handleClose() {
      this.setHighlighted({ pand_id: false })
      this.pand_id = false
    },

    getCenterOfPolygon({ coordinates }) {
      let bounds = coordinates.reduce((bounds, coord) => {
        return bounds.extend(coord);
      }, new mapboxgl.LngLatBounds(coordinates[0], coordinates[0]))
      return bounds.getCenter()
    },
    flyTo() {
      this.$store.map.flyTo({ center: this.coordinates, zoom: 17 })
    }
  }
}
</script>

<style lang="scss">
.TileData {
  // height: 300px;
  width: 275px;
  background: #081736; //white;
  color: white; // #7F8FA4;
  padding: 10px 15px 25px;
  box-shadow: 0px -1px 0px 0px rgba(223,226,229,1) inset;


  &__title {
    font-weight: bold;
    font-size: 1.2rem;

    svg:hover {
      cursor: pointer;
      color: red;
    }
  }

  &__highlighted {
    color: #ff883c;
  }
  tr {
    display: block;
    margin: 2px 0;
  }
  td:first-child {
    width: 135px;
  }
}
</style>
